import request from '../utils/chatRequest'
import { chatApiUrl } from '../utils/config'

/**
 * 聊天相关接口
 */

// 获取用户聊天状态（是否禁用、是否管理员、未读数、在线人数）
export function getChatStatus(userId) {
  return request({
    url: '/chat/status',
    method: 'get',
    params: { userId }
  })
}

// 获取历史消息（firstJoinTime限制可见范围，只返回该时间之后的消息）
export function getChatHistory(userId, maxId = 0, minId = 0, pageSize = 50, firstJoinTime = '') {
  return request({
    url: '/chat/history',
    method: 'get',
    params: { userId, maxId, minId, pageSize, firstJoinTime }
  })
}

// 增量同步（基于版本号 + 最早时间）
export function syncChatMessages(userId, localVersion = 0, pageSize = 100, firstJoinTime = '') {
  return request({
    url: '/chat/sync',
    method: 'get',
    params: { userId, localVersion, pageSize, firstJoinTime }
  })
}

// 标记已读
export function markChatRead(userId) {
  return request({
    url: '/chat/read',
    method: 'post',
    data: { userId }
  })
}

// 发送消息（图片消息时传 thumbUrl）
export function sendChatMessage(userId, msgType, content, thumbUrl = '') {
  return request({
    url: '/chat/send',
    method: 'post',
    data: { userId, msgType, content, thumbUrl }
  })
}

// 上传聊天图片
export function uploadChatImage(userId, file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/chat/upload',
    method: 'post',
    params: { userId },
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// ========== 管理员接口 ==========

// 获取用户列表（带禁用状态）
export function getChatUserList(adminId, keyword = '', page = 1, pageSize = 20) {
  return request({
    url: '/chat/admin/users',
    method: 'get',
    params: { adminId, keyword, page, pageSize }
  })
}

// 禁用用户聊天
export function banChatUser(adminId, userId, remark = '') {
  return request({
    url: '/chat/admin/ban',
    method: 'post',
    data: { adminId, userId, remark }
  })
}

// 恢复用户聊天
export function unbanChatUser(adminId, userId, remark = '') {
  return request({
    url: '/chat/admin/unban',
    method: 'post',
    data: { adminId, userId, remark }
  })
}

// 获取禁用操作日志
export function getChatBanLogs(adminId, page = 1, pageSize = 20) {
  return request({
    url: '/chat/admin/ban-logs',
    method: 'get',
    params: { adminId, page, pageSize }
  })
}

// 图片完整URL（拼接聊天服务域名）
export function getChatImageUrl(path) {
  if (!path) return ''
  if (path.startsWith('http')) return path
  return chatApiUrl + path
}
